(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name leaveReport.controller:LeaveReportCtrl
	 *
	 * @description
	 *
	 */
	angular.module('leaveReport')
			.controller('LeaveReportCtrl', LeaveReportCtrl);

	function LeaveReportCtrl(CommonMasterData, $sce, CommonLogicService, CrewingHelper, EventManagerService, $scope) {
		var vm = this;
		vm.ctrlName = 'LeaveReportCtrl';
		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				crewType : null,
				isDateOfContract : false,
        crewIds : '',
        selectedCrewId : null
			},
			masterList : {
				crewTypeList : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
				fromDateRequired : false,
        crewIdsInvalid : false,
        isCrewIdsLoaded : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
      validateCrewIdsAndSearch(params);
		};

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags(flag === 'FromDate');
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
			if (flag === 'crewType') {
			  if (typeof(vm.model.searchCriteria.crewType) === 'undefined') {
			    vm.model.masterList.isCrewIdsLoaded = false;
        }
			  else {
          loadCrewListByType();
          vm.model.masterList.isCrewIdsLoaded = true;
        }
      }
			else if (flag === 'crewId' || flag === 'toDate' || flag === 'fromDate') {
      }
			else if (flag === 'addId') {
			  addCrewIDs();
      }
			else if (flag !== '') {
        removeCrewIDs(flag);
      }

		};

    function loadCrewListByType(){
      var param={};
      param.crewType = vm.model.searchCriteria.crewType.crewTypeCode;
      param.active = true;
      CommonMasterData.loadCrewList(param,
        function (response) {
          vm.model.masterList.crewList = CrewingHelper.adaptCrewList(response);
          EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.CREW_LIST_UPDATED);
        },
        function () {
          console.log('Crew list retrieval error');
        }
      );

    }

    function removeCrewIDs(selected) {
      for( var i = 0; i < vm.model.masterList.crewIdList.length; i++){
        if ( vm.model.masterList.crewIdList[i].crewId === selected) {
          vm.model.masterList.crewIdList.splice(i, 1);
        }
      }
    }

    function addCrewIDs() {
      if(!!!vm.model.masterList.crewIdList){
        vm.model.masterList.crewIdList = [];
      }
      var alreadyAvailable = false;
      for( var i = 0; i < vm.model.masterList.crewIdList.length; i++){
        if (vm.model.masterList.crewIdList[i] === vm.model.searchCriteria.selectedCrewId) {
          alreadyAvailable = true;
        }
      }
      if (alreadyAvailable === false) {
        vm.model.masterList.crewIdList.push(vm.model.searchCriteria.selectedCrewId);
      }
      vm.model.searchCriteria.selectedCrewId = null;
    }

		function setDateValidationFlags(isFromDateChanged) {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
				if(!vm.model.searchCriteria.isDateOfContract){
					if(!!vm.model.searchCriteria.fromDate){
						vm.model.masterList.fromDateRequired = false;
					}else{
						vm.model.masterList.fromDateRequired = true;
					}
				}else {
					vm.model.masterList.fromDateRequired = false;
					if(!isFromDateChanged){
						vm.model.searchCriteria.fromDate = null;
					}
				}
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// search Leave Report
		function searchLeaveReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService
						.getReportUrl('leave_report.rptdesign',
								getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["toDate"] = param.toDate;
			searchParamMap["crewType"] = param.crewType.crewTypeCode;
			searchParamMap["crewIds"] = param.crewIds;
			if (param.isDateOfContract) {
				searchParamMap["doc"] = 'Y';
			} else {
				searchParamMap["fromDate"] = param.fromDate;
				searchParamMap["doc"] = 'N';
			}
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags(false);
			// if date invalid
			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid
					|| vm.model.masterList.fromDateRequired) {
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
				return false;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
				if(!!vm.model.searchCriteria.crewType){
					return true;
				}
				return false;
			}
		}

    function validateCrewIdsAndSearch(param) {
		  param.crewIds = '';
		  if (typeof vm.model.masterList.crewIdList != 'undefined') {
        for( var i = 0; i < vm.model.masterList.crewIdList.length; i++){
          if (i === 0) {
            param.crewIds = vm.model.masterList.crewIdList[i].crewId;
          }
          else {
            param.crewIds = param.crewIds + "," + vm.model.masterList.crewIdList[i].crewId;
          }
        }
      }

      CommonMasterData.getCrewTypesForCrewIds(param.crewIds,param.fromDate,param.toDate, function(response) {
          if (param.crewIds === null || param.crewIds === "" || checkCrewValidity(response)){
            vm.model.masterList.crewIdsInvalid = false;
            searchLeaveReport(param);
          }
        }, function(error) {
          console.log("Error validating crew ids");
        }
      );
    }

    function checkCrewValidity(resultList) {
      if (resultList.length === 1) {
        if (typeof vm.model.searchCriteria.crewType === 'undefined') {
          vm.model.searchCriteria.crewType = {};
          return false;
        } else if (resultList[0] === vm.model.searchCriteria.crewType.crewTypeCode){
          vm.model.masterList.crewIdsInvalid = false;
          return true;
        }
        else {
          vm.model.masterList.crewIdsInvalid = true;
          return false;
        }
      } else {
        vm.model.masterList.crewIdsInvalid = true;
        return false;
      }
    }

		(function() {
			// crew type codes
			CommonMasterData.getCrewTypeList(function(crewTypeList) {
				vm.model.masterList.crewTypeList = crewTypeList;
			}, function() {
				console.log('Crew Type list retrieval error');
			});

		})();
	}
}());
